import { Card, CardContent } from '@/components/ui/card';
import { SITE_CONFIG } from '@/lib/constants';

/**
 * Disclaimer page
 */
export function Disclaimer() {
  const lastUpdated = '16/12/2025';

  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <span className="category-label">Legal</span>
          <h1 className="text-4xl font-bold">Disclaimer</h1>
          <p className="mt-4 text-muted-foreground">
            Last updated: {lastUpdated}
          </p>

          <Card className="mt-8">
            <CardContent className="prose prose-invert max-w-none p-6 md:p-8">
              <div className="space-y-8">
                <section>
                  <h2 className="text-xl font-semibold text-foreground">1. General Information</h2>
                  <p className="mt-2 text-muted-foreground">
                    The information provided on this website is for general informational
                    purposes only. While we strive to keep the information accurate and
                    up to date, {SITE_CONFIG.name} makes no representations or warranties
                    of any kind, express or implied, about the completeness, accuracy,
                    reliability, or availability of the website or the information,
                    products, services, or related graphics contained on the website.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">2. Service Results Disclaimer</h2>
                  <p className="mt-2 text-muted-foreground">
                    Results from our services may vary based on factors including but
                    not limited to:
                  </p>
                  <ul className="mt-2 list-disc pl-5 text-muted-foreground space-y-1">
                    <li>
                      <strong>Gardening:</strong> Weather conditions, soil quality,
                      existing plant health, and seasonal factors
                    </li>
                    <li>
                      <strong>Cleaning:</strong> Pre-existing stains, damage, or material
                      types that may affect cleaning outcomes
                    </li>
                    <li>
                      <strong>Taxidermy:</strong> Condition of the specimen upon receipt,
                      species-specific characteristics, and preservation limitations
                    </li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">3. Gallery Images</h2>
                  <p className="mt-2 text-muted-foreground">
                    Images displayed in our gallery are representative of our work. Each
                    taxidermy piece is unique, and commissioned work may differ from
                    displayed examples based on the individual specimen, client preferences,
                    and artistic interpretation.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">4. Price Estimates</h2>
                  <p className="mt-2 text-muted-foreground">
                    All prices are provided upon request and are estimates only until a
                    formal quote is issued. Final pricing may vary based on actual job
                    requirements, access conditions, materials needed, and unforeseen
                    circumstances discovered during service delivery.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">5. External Links</h2>
                  <p className="mt-2 text-muted-foreground">
                    This website may contain links to external websites that are not
                    operated by us. We have no control over the content and nature of
                    these sites and are not responsible for their content, privacy
                    policies, or practices.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">6. Professional Advice</h2>
                  <p className="mt-2 text-muted-foreground">
                    Information on this website should not be considered professional
                    advice. For specific guidance regarding wildlife regulations, permits,
                    or legal requirements, please consult the relevant authorities or
                    seek professional legal advice.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">7. Limitation of Liability</h2>
                  <p className="mt-2 text-muted-foreground">
                    To the fullest extent permitted by law, {SITE_CONFIG.name} shall not
                    be liable for any indirect, incidental, special, consequential, or
                    punitive damages arising out of or related to your use of this
                    website or our services.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">8. Contact</h2>
                  <p className="mt-2 text-muted-foreground">
                    If you have questions about this disclaimer, please contact us at{' '}
                    <a
                      href={`mailto:${SITE_CONFIG.contact.email}`}
                      className="text-primary hover:underline"
                    >
                      {SITE_CONFIG.contact.email}
                    </a>
                    .
                  </p>
                </section>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
}
